import { useState, useMemo } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import SEOHead from '@/components/base/SEOHead';
import Breadcrumb from '@/components/base/Breadcrumb';
import { productCategories } from '@/mocks/products';

const productImages: Record<number, string> = {
  1: 'https://readdy.ai/api/search-image?query=A%20minimalist%20product%20photography%20of%20a%20serum%20bottle%20with%20peony%20flowers%2C%20soft%20warm%20lighting%20on%20cream%20background%2C%20oriental%20aesthetic%2C%20clean%20composition&width=600&height=600&seq=prod-sk-01&orientation=squarish',
  2: 'https://readdy.ai/api/search-image?query=A%20minimalist%20product%20photography%20of%20a%20luxury%20face%20cream%20jar%20with%20natural%20herbs%2C%20soft%20warm%20lighting%20on%20cream%20background%2C%20oriental%20aesthetic&width=600&height=600&seq=prod-sk-02&orientation=squarish',
  3: 'https://readdy.ai/api/search-image?query=A%20minimalist%20product%20photography%20of%20a%20facial%20cleanser%20bottle%20with%20green%20leaves%2C%20soft%20warm%20lighting%20on%20cream%20background%2C%20oriental%20aesthetic&width=600&height=600&seq=prod-sk-03&orientation=squarish',
  4: 'https://readdy.ai/api/search-image?query=A%20minimalist%20product%20photography%20of%20facial%20sheet%20masks%20with%20flower%20petals%2C%20soft%20warm%20lighting%20on%20cream%20background%2C%20oriental%20aesthetic&width=600&height=600&seq=prod-sk-04&orientation=squarish',
  5: 'https://readdy.ai/api/search-image?query=A%20minimalist%20product%20photography%20of%20a%20sunscreen%20tube%20with%20botanical%20elements%2C%20soft%20warm%20lighting%20on%20cream%20background%2C%20oriental%20aesthetic&width=600&height=600&seq=prod-sk-05&orientation=squarish',
  6: 'https://readdy.ai/api/search-image?query=A%20minimalist%20product%20photography%20of%20an%20eye%20cream%20jar%20with%20delicate%20flowers%2C%20soft%20warm%20lighting%20on%20cream%20background%2C%20oriental%20aesthetic&width=600&height=600&seq=prod-sk-06&orientation=squarish',
  7: 'https://readdy.ai/api/search-image?query=A%20minimalist%20product%20photography%20of%20a%20reed%20diffuser%20with%20dried%20botanicals%2C%20soft%20warm%20lighting%20on%20cream%20background%2C%20oriental%20aesthetic&width=600&height=600&seq=prod-fr-01&orientation=squarish',
  8: 'https://readdy.ai/api/search-image?query=A%20minimalist%20product%20photography%20of%20a%20soy%20candle%20in%20ceramic%20jar%20with%20reeds%2C%20soft%20warm%20lighting%20on%20cream%20background%2C%20oriental%20aesthetic&width=600&height=600&seq=prod-fr-02&orientation=squarish',
  9: 'https://readdy.ai/api/search-image?query=A%20minimalist%20product%20photography%20of%20a%20perfume%20bottle%20with%20peach%20blossoms%2C%20soft%20warm%20lighting%20on%20cream%20background%2C%20oriental%20aesthetic&width=600&height=600&seq=prod-fr-03&orientation=squarish',
  10: 'https://readdy.ai/api/search-image?query=A%20minimalist%20product%20photography%20of%20a%20fabric%20sachet%20with%20embroidery%2C%20soft%20warm%20lighting%20on%20cream%20background%2C%20oriental%20aesthetic&width=600&height=600&seq=prod-fr-04&orientation=squarish',
  11: 'https://readdy.ai/api/search-image?query=A%20minimalist%20product%20photography%20of%20incense%20sticks%20in%20a%20ceramic%20holder%2C%20soft%20warm%20lighting%20on%20cream%20background%2C%20oriental%20aesthetic&width=600&height=600&seq=prod-fr-05&orientation=squarish',
  12: 'https://readdy.ai/api/search-image?query=A%20minimalist%20product%20photography%20of%20a%20closet%20fragrance%20tag%2C%20soft%20warm%20lighting%20on%20cream%20background%2C%20oriental%20aesthetic&width=600&height=600&seq=prod-fr-06&orientation=squarish',
  13: 'https://readdy.ai/api/search-image?query=A%20minimalist%20product%20photography%20of%20white%20tea%20leaves%20in%20a%20ceramic%20bowl%2C%20soft%20warm%20lighting%20on%20cream%20background%2C%20oriental%20aesthetic&width=600&height=600&seq=prod-te-01&orientation=squarish',
  14: 'https://readdy.ai/api/search-image?query=A%20minimalist%20product%20photography%20of%20oolong%20tea%20leaves%20in%20a%20clay%20pot%2C%20soft%20warm%20lighting%20on%20cream%20background%2C%20oriental%20aesthetic&width=600&height=600&seq=prod-te-02&orientation=squarish',
  15: 'https://readdy.ai/api/search-image?query=A%20minimalist%20product%20photography%20of%20green%20tea%20leaves%20in%20a%20white%20bowl%2C%20soft%20warm%20lighting%20on%20cream%20background%2C%20oriental%20aesthetic&width=600&height=600&seq=prod-te-03&orientation=squarish',
  16: 'https://readdy.ai/api/search-image?query=A%20minimalist%20product%20photography%20of%20black%20tea%20leaves%20in%20a%20ceramic%20bowl%2C%20soft%20warm%20lighting%20on%20cream%20background%2C%20oriental%20aesthetic&width=600&height=600&seq=prod-te-04&orientation=squarish',
  17: 'https://readdy.ai/api/search-image?query=A%20minimalist%20product%20photography%20of%20aged%20puerh%20tea%20cake%2C%20soft%20warm%20lighting%20on%20cream%20background%2C%20oriental%20aesthetic&width=600&height=600&seq=prod-te-05&orientation=squarish',
  18: 'https://readdy.ai/api/search-image?query=A%20minimalist%20product%20photography%20of%20chrysanthemum%20flower%20tea%20in%20a%20glass%20cup%2C%20soft%20warm%20lighting%20on%20cream%20background%2C%20oriental%20aesthetic&width=600&height=600&seq=prod-te-06&orientation=squarish',
  19: 'https://readdy.ai/api/search-image?query=A%20minimalist%20product%20photography%20of%20handmade%20ceramic%20tea%20set%2C%20soft%20warm%20lighting%20on%20cream%20background%2C%20oriental%20aesthetic&width=600&height=600&seq=prod-ho-01&orientation=squarish',
  20: 'https://readdy.ai/api/search-image?query=A%20minimalist%20product%20photography%20of%20handwoven%20bamboo%20basket%2C%20soft%20warm%20lighting%20on%20cream%20background%2C%20oriental%20aesthetic&width=600&height=600&seq=prod-ho-02&orientation=squarish',
  21: 'https://readdy.ai/api/search-image?query=A%20minimalist%20product%20photography%20of%20calligraphy%20brush%20and%20ink%20stone%20set%2C%20soft%20warm%20lighting%20on%20cream%20background%2C%20oriental%20aesthetic&width=600&height=600&seq=prod-ho-03&orientation=squarish',
  22: 'https://readdy.ai/api/search-image?query=A%20minimalist%20product%20photography%20of%20handmade%20paper%20notebook%20with%20linen%20cover%2C%20soft%20warm%20lighting%20on%20cream%20background%2C%20oriental%20aesthetic&width=600&height=600&seq=prod-ho-04&orientation=squarish',
  23: 'https://readdy.ai/api/search-image?query=A%20minimalist%20product%20photography%20of%20brocade%20cushion%20cover%2C%20soft%20warm%20lighting%20on%20cream%20background%2C%20oriental%20aesthetic&width=600&height=600&seq=prod-ho-05&orientation=squarish',
  24: 'https://readdy.ai/api/search-image?query=A%20minimalist%20product%20photography%20of%20a%20brass%20incense%20burner%2C%20soft%20warm%20lighting%20on%20cream%20background%2C%20oriental%20aesthetic&width=600&height=600&seq=prod-ho-06&orientation=squarish',
};

export default function Categories() {
  const [searchParams, setSearchParams] = useSearchParams();
  const activeTab = searchParams.get('tab') || productCategories[0].id;

  const activeCategory = useMemo(
    () => productCategories.find((c) => c.id === activeTab) || productCategories[0],
    [activeTab],
  );

  const handleTabChange = (tabId: string) => {
    setSearchParams({ tab: tabId });
    window.scrollTo({ top: 0, behavior: 'instant' });
  };

  return (
    <>
      <SEOHead
        title="产品系列"
        description="探索呦呦四大产品系列——护肤、香氛、茶品、家居，感受东方美学与现代生活的完美融合。每一款产品都承载着《诗经》的千年意境。"
        canonicalUrl="https://yooyoozone.github.io/categories"
      />
      <ScrollToTop />
      <Navbar />

      <main className="pt-20 md:pt-24">
        <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
          <Breadcrumb
            items={[
              { label: '首页', path: '/' },
              { label: '产品系列' },
            ]}
          />

          <div className="mb-10">
            <h1 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-950">
              产品系列
            </h1>
            <p className="mt-2 text-sm text-foreground-500">
              四大系列，构筑完整的东方生活美学体系
            </p>
          </div>

          {/* Category Tabs */}
          <div className="flex flex-wrap gap-2 mb-10">
            {productCategories.map((cat) => (
              <button
                key={cat.id}
                onClick={() => handleTabChange(cat.id)}
                className={`px-5 py-2 rounded-full text-sm font-medium transition-all duration-300 whitespace-nowrap cursor-pointer ${
                  activeTab === cat.id
                    ? 'bg-primary-500 text-background-50'
                    : 'bg-background-100 text-foreground-600 hover:bg-background-200'
                }`}
              >
                {cat.name}
              </button>
            ))}
          </div>

          {/* Category Description */}
          <div className="mb-10 p-6 bg-background-100 rounded-lg">
            <h2 className="font-heading text-lg font-semibold text-foreground-900">
              {activeCategory.name}
            </h2>
            <p className="mt-2 text-sm text-foreground-500 leading-relaxed max-w-2xl">
              {activeCategory.description}
            </p>
          </div>

          {/* Product Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6 pb-16" data-product-shop>
            {activeCategory.products.map((product) => (
              <div
                key={product.id}
                className="group rounded-lg overflow-hidden bg-background-50 border border-background-200/60 hover:border-primary-200 transition-all duration-300"
              >
                <div className="relative h-64 md:h-72 overflow-hidden bg-background-100">
                  <img
                    src={productImages[product.id]}
                    alt={product.name}
                    title={`${product.name} 呦呦官方正品`}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="p-5">
                  <h3 className="font-heading text-sm font-semibold text-foreground-900">
                    {product.name}
                  </h3>
                  <p className="mt-1.5 text-xs text-foreground-500 leading-relaxed">
                    {product.desc}
                  </p>
                  <div className="mt-3 flex items-center justify-between">
                    <span className="text-sm font-semibold text-primary-600">
                      {product.price}
                    </span>
                    <span className="text-xs text-foreground-400">
                      查看详情
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </main>

      <Footer />
    </>
  );
}